import { Badge } from 'react-bootstrap';
import { formatCurrency, formatPercent } from '../../utils/formatters';

const CurrentBenefitInfoPanel = ({ currentDiscount, priorPledge }) => {

  return (
      <div className="text-muted">
        <strong>Current Benefits</strong>
        <hr/>
        <span>Energy Discount: </span><Badge bg={currentDiscount? 'success': 'secondary'}>{formatPercent(currentDiscount)}</Badge>
        <br />
        <span>Prior Grant: </span><Badge bg={priorPledge? 'success': 'secondary'}>{priorPledge == null? '-': formatCurrency(priorPledge)}</Badge>
    </div>
  );
};

export default CurrentBenefitInfoPanel;